import setCustomerAddrOnShippingAddr from './setCustomerAddrOnShippingAddr';

export default setCustomerAddrOnShippingAddr;
